// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_np-0";
export var animationContainer = "_np-1";
export var itemPrice = "_np-a";
export var itemizedContent = "_np-9";
export var itemizedHeader = "_np-7";
export var itemizedRow = "_np-8";
export var itemizedSection = "_np-6";
export var modalContent = "_np-2";
export var orderName = "_np-3";
export var refundOption = "_np-4";
export var refundOptionsContainer = "_np-5";
export var shippingLabel = "_np-b";
export var totalRow = "_np-c";